import { WarningProps } from '@texas/components/shared/WarningComponent';
import { WarningItem } from '@texas/components/shared/WarningSummary';

export function getActiveWarnings(
  fields: Record<string, WarningProps>,
  scope: string,
): WarningItem[] {
  return Object.entries(fields).flatMap(([field, props]) =>
    props.warning
      ? [
          {
            id: `${scope}.${field}`,
            targetId: props.targetId,
            message: props.warning,
            mandatory: props.isMandatory === true,
          },
        ]
      : [],
  );
}

export function mandatoryWarning(
  condition: boolean,
  message: string,
): WarningProps {
  return { warning: condition ? message : undefined, isMandatory: true };
}

export function withWarningTargets<T extends Record<string, WarningProps>>(
  fields: T,
  scope: string,
): T {
  return Object.fromEntries(
    Object.entries(fields).map(([field, props]) => [
      field,
      { ...props, targetId: `${scope}.${field}` },
    ]),
  ) as T;
}
